export default "__VITE_ASSET__I_I34Ip___"